import { createContext, useContext, useEffect, useState } from 'react';

interface AffiliateClient {
  isInitialized: boolean;
}

const AffiliatesContext = createContext<AffiliateClient>({
  isInitialized: false,
});

function initializeFirstPromoter(): Promise<AffiliateClient> {
  return new Promise((resolve) => {
    // Initialize FPR script
    const script1 = document.createElement('script');
    script1.textContent = `(function(w){w.fpr=w.fpr||function(){w.fpr.q = w.fpr.q||[];w.fpr.q[arguments[0]=='set'?'unshift':'push'](arguments);};})(window);
    fpr("init", {cid:"g7ya6g4v"}); 
    fpr("click");`;

    // Load FPR main script
    const script2 = document.createElement('script');
    script2.async = true;
    script2.src = 'https://cdn.firstpromoter.com/fpr.js';

    const head = document.getElementsByTagName('head')[0];
    head.appendChild(script1);
    head.appendChild(script2);

    // Set up timeout
    const timeoutId = setTimeout(() => {
      console.warn('First Promoter failed to initialize within timeout');
      resolve({ isInitialized: false });
    }, 10000);

    // Wait for script to load
    script2.onload = () => {
      clearTimeout(timeoutId); // Clear the timeout when script loads
      console.log('First Promoter initialized');
      resolve({ isInitialized: true });
    };
  });
}

export function AffiliatesProvider({ children }: { children: React.ReactNode }) {
  const [client, setClient] = useState<AffiliateClient>({ isInitialized: false });

  useEffect(() => {
    initializeFirstPromoter().then(setClient);
  }, []);

  return <AffiliatesContext.Provider value={client}>{children}</AffiliatesContext.Provider>;
}

export function useAffiliates() {
  return useContext(AffiliatesContext);
}
